import React from "react";
import TextField from "@material-ui/core/TextField";

export const MuiTextField = (props) => {
  return (
    <TextField
      {...props}
      {...props.inputProps}
      style={{ backgroundColor: "white" }}
      variant="outlined"
    />
  );
};
